import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Transaction, TransactionCreate, TransactionsQuery } from './transactions.model';
import { TRANS_STATUS } from './transaction.constants';
import { OrderResult } from '../orders/order.models';
import { transacStatuses } from './transaction-statuses';

@Injectable()
export class TransactionsService {
    API_URL = environment.apiUrl;

    transacStatuses = transacStatuses;

    constructor(
        private http: HttpClient,
    ) { }

    listOrder(orderId: string) {
        return this.http.get<Transaction[]>(`${environment.apiUrl}/orders/${orderId}/transactions`);
    }

    list(query: TransactionsQuery) {
        let params = new HttpParams();
        if (query.statut && query.statut.length) {
            params = params.set('statut', query.statut);
        }
        if (query.type && query.type.length) {
            params = params.set('type', query.type);
        }
        if (query.from) {
            params = params.set('from', query.from.toISOString());
        }
        if (query.to) {
            params = params.set('to', query.to.toISOString());
        }
        return this.http.get<Transaction[]>(`${environment.apiUrl}/transactions`, {
            params
        });
    }

    add(data: TransactionCreate) {
        return this.http.put<OrderResult>(`${environment.apiUrl}/orders/transaction`, data);
    }
    // list(status?: string) {
    //     return this.http.get<TransactionResult[]>(`${environment.apiUrl}/orders/transactions`, {
    //         params: {status: status}
    //     });
    // }


    dueAmount(orderId: string) {
        return this.http.get<number>(`${environment.apiUrl}/orders/${orderId}/due`);
    }

    getStatusClass(val: string) {
        const res = this.transacStatuses.find(el => el.name === val);
        if (res) {
            return res.color;
        }
        return '';
    }

}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/transactions/transactions.service.ts